import React, {createContext, useContext} from "react";
import {MsalContext} from "@azure/msal-react";
import axios from "axios";
import {loginRequest} from "../authConfig";

export const HttpClientContext = createContext(null);
const HttpClientProvider = ({children}) => {
    const {instance, accounts} = useContext(MsalContext);
    const accessToken = instance.acquireTokenSilent(loginRequest);

    const httpClient = axios.create({
        baseURL: window.location.protocol + "//" + window.location.host + "/api",
        headers: {
            "Content-type": "application/json",
            "Authorization": `Bearer ${accessToken}`
        }
    });

    return (
        <HttpClientContext.Provider value={httpClient}>
            {children}
        </HttpClientContext.Provider>
    );
}

export {HttpClientContext as default, HttpClientProvider}